import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrl: './search-bar.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent {
  @Output() readonly onSearch = new EventEmitter<string>();

  value = '';
  text = '';
  // skipcq: JS-0323
  timmer?: any;

  // skipcq: JS-0323
  handleSearch(e: Event) {
    if(this.timmer !== undefined){
      clearInterval(this.timmer);
    }
    this.timmer  = setInterval(() =>
    {
      clearInterval(this.timmer);
      this.timmer = undefined;
      const searchText = (e.target as HTMLInputElement).value;

      if (this.text === searchText) return;

      this.text = searchText;
      this.onSearch.emit(this.text);
    }, 800);
  }
}
